import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { YshButtonComponent } from '../../../components/ysh-button/ysh-button.component';
import { YshButtonControlComponent } from '../../../components/ysh-button-control/ysh-button-control.component';
import { YshBadgeComponent } from '../../../components/ysh-badge/ysh-badge.component';
import { YshDotsComponent } from '../../../components/ysh-dots/ysh-dots.component';
import { ModalService } from '../../../services/ui/modal/modal.service';
import { ToastService } from '../../../services/ui/toast/toast.service';
import { IntegrationService } from '../../../services/api/integration/integration.service';
import { WebhookDelivery } from '../../../models/webhook-delivery';

@Component({
    selector: 'app-webhook-delivery-detail',
    templateUrl: './webhook-delivery-detail.component.html',
    styleUrl: './webhook-delivery-detail.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatIconModule,
    YshButtonComponent,
    YshButtonControlComponent,
    YshBadgeComponent,
    YshDotsComponent
]
})
export class WebhookDeliveryDetailComponent implements OnInit {
  @Input() companyUid!: string;
  @Input() eventId!: string;
  /** Called after a successful resend so the list can refresh. */
  @Input() onResend?: () => void;

  delivery?: WebhookDelivery;
  loading = true;
  resending = false;

  constructor(
    private integrationService: IntegrationService,
    private modalService: ModalService,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.loadDelivery();
  }

  private loadDelivery(): void {
    this.loading = true;
    this.integrationService.getDelivery(this.companyUid, this.eventId).subscribe({
      next: (delivery) => {
        this.delivery = delivery;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.toast.show('error', 'Unable to load delivery details.');
      },
    });
  }

  handleResend(): void {
    if (this.resending || !this.delivery) {
      return;
    }
    this.resending = true;
    this.integrationService.retryDelivery(this.companyUid, this.delivery.eventId).subscribe({
      next: (delivery) => {
        this.delivery = delivery;
        this.resending = false;
        this.toast.show('success', 'Delivery re-sent.');
        this.onResend?.();
      },
      error: (err) => {
        this.resending = false;
        const message = err?.error?.message || err?.error?.errors?.[0]?.message || 'Unable to re-send delivery.';
        this.toast.show('error', message);
      },
    });
  }

  handleClose(): void {
    this.modalService.dismiss();
  }
}
